import { RULESET as y, DECLARATION as A, COMMENT as F } from "./index.es94.js";
import { from as K, strlen as O, append as I, charat as G, replace as R, indexof as P, abs as q, sizeof as Q, substr as U, trim as T } from "./index.es135.js";
import { dealloc as V, alloc as W, next as j, prev as X, peek as z, delimit as B, identifier as Y, commenter as Z, escaping as _, whitespace as g, node as E, char as w, caret as C } from "./index.es136.js";
function ce(s) {
  return V(S("", null, null, null, [""], s = W(s), 0, [0], s));
}
function S(s, f, i, c, n, N, D, o, p) {
  for (var b = 0, d = 0, r = D, M = 0, k = 0, x = 0, t = 1, v = 1, u = 1, a = 0, m = "", L = n, h = N, l = c, e = m; v; )
    switch (x = a, a = j()) {
      // (
      case 40:
        if (x != 108 && G(e, r - 1) == 58) {
          P(e += R(B(a), "&", "&\f"), "&\f", q(b ? o[b - 1] : 0)) != -1 && (u = -1);
          break;
        }
      // " ' [
      case 34:
      case 39:
      case 91:
        e += B(a);
        break;
      // \t \n \r \s
      case 9:
      case 10:
      case 13:
      case 32:
        e += g(x);
        break;
      // \
      case 92:
        e += _(C() - 1, 7);
        continue;
      // /
      case 47:
        switch (z()) {
          case 42:
          case 47:
            I($(Z(j(), C()), f, i, p), p);
            break;
          default:
            e += "/";
        }
        break;
      // {
      case 123 * t:
        o[b++] = O(e) * u;
      // } ; \0
      case 125 * t:
      case 59:
      case 0:
        switch (a) {
          // \0 }
          case 0:
          case 125:
            v = 0;
          // ;
          case 59 + d:
            u == -1 && (e = R(e, /\f/g, "")), k > 0 && O(e) - r && I(k > 32 ? J(e + ";", c, i, r - 1, p) : J(R(e, " ", "") + ";", c, i, r - 2, p), p);
            break;
          // @ ;
          case 59:
            e += ";";
          // { rule/at-rule
          default:
            if (I(l = H(e, f, i, b, d, n, o, m, L = [], h = [], r, N), N), a === 123)
              if (d === 0)
                S(e, f, l, l, L, N, r, o, h);
              else
                switch (M === 99 && G(e, 3) === 110 ? 100 : M) {
                  // d l m s
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    S(s, l, l, c && I(H(s, l, l, 0, 0, n, o, m, n, L = [], r, h), h), n, h, r, o, c ? L : h);
                    break;
                  default:
                    S(e, l, l, l, [""], h, 0, o, h);
                }
        }
        b = d = k = 0, t = u = 1, m = e = "", r = D;
        break;
      // :
      case 58:
        r = 1 + O(e), k = x;
      default:
        if (t < 1) {
          if (a == 123)
            --t;
          else if (a == 125 && t++ == 0 && X() == 125)
            continue;
        }
        switch (e += K(a), a * t) {
          // &
          case 38:
            u = d > 0 ? 1 : (e += "\f", -1);
            break;
          // ,
          case 44:
            o[b++] = (O(e) - 1) * u, u = 1;
            break;
          // @
          case 64:
            z() === 45 && (e += B(j())), M = z(), d = r = O(m = e += Y(C())), a++;
            break;
          // -
          case 45:
            x === 45 && O(e) == 2 && (t = 0);
        }
    }
  return N;
}
function H(s, f, i, c, n, N, D, o, p, b, d, r) {
  for (var M = n - 1, k = n === 0 ? N : [""], x = Q(k), t = 0, v = 0, u = 0; t < c; ++t)
    for (var a = 0, m = U(s, M + 1, M = q(v = D[t])), L = s; a < x; ++a)
      (L = T(v > 0 ? k[a] + " " + m : R(m, /&\f/g, k[a]))) && (p[u++] = L);
  return E(s, f, i, n === 0 ? y : o, p, b, d, r);
}
function $(s, f, i, c) {
  return E(s, f, i, F, K(w()), U(s, 2, -2), 0, c);
}
function J(s, f, i, c, n) {
  return E(s, f, i, A, U(s, 0, c), U(s, c + 1, -1), c, n);
}
export {
  $ as comment,
  ce as compile,
  J as declaration,
  S as parse,
  H as ruleset
};
//# sourceMappingURL=index.es97.js.map
